import { api } from './baseApi';
export var chatsApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getUserChatsSummary: builder.query({
                query: function (_a) {
                    var userId = _a.userId;
                    return ({
                        url: "/chats/user/".concat(userId, "/summary"),
                        method: 'GET',
                    });
                },
                providesTags: ['Chats'],
            }),
            getChatsByRestId: builder.query({
                query: function (params) {
                    return ({
                        url: "/chats/findAllChatsByRestaurantId/".concat(params.restaurantId),
                        method: 'GET',
                        // params: {params.restaurantId},
                        // credentials: 'include',
                        // params: params,
                    });
                },
                providesTags: ['Chats'],
            }),
            getChatsByRestIdWithPagination: builder.query({
                query: function (_a) {
                    var page = _a.page, limit = _a.limit, search = _a.search, restaurantId = _a.restaurantId, isArchived = _a.isArchived;
                    return ({
                        url: "/chats/searchChatsWithPagination",
                        method: 'GET',
                        params: { page: page, limit: limit, search: search, restaurantId: restaurantId, isArchived: isArchived },
                    });
                },
                providesTags: ['Chats'],
            }),
            getChatById: builder.query({
                query: function (id) {
                    return ({
                        method: 'GET',
                        url: "/chats/".concat(id),
                    });
                }
            }),
            getAllMessages: builder.query({
                query: function (_a) {
                    var restaurantId = _a.restaurantId;
                    return ({
                        method: 'GET',
                        url: "/chats/allMessagesForRestaurant/".concat(restaurantId),
                    });
                }
            }),
            getAllMessagesWithSearch: builder.query({
                query: function (_a) {
                    var page = _a.page, limit = _a.limit, search = _a.search, restaurantId = _a.restaurantId;
                    return ({
                        method: 'GET',
                        url: '/chats/searchAllMessagesWithPagination',
                        params: { page: page, limit: limit, search: search, restaurantId: restaurantId }
                    });
                }
            }),
            createChat: builder.mutation({
                query: function (body) {
                    return ({
                        method: 'POST',
                        url: "/chats",
                        body: body,
                    });
                },
                invalidatesTags: ['Chats'],
            }),
            updateIsPaidStatus: builder.mutation({
                query: function (_a) {
                    var chatId = _a.chatId, isPaid = _a.isPaid;
                    return ({
                        url: "/chats/".concat(chatId, "/update-status"),
                        method: 'PATCH',
                        body: { isPaid: isPaid },
                    });
                },
                invalidatesTags: ['Chats'], // Optionally invalidate cache if necessary
            }),
            deleteChat: builder.mutation({
                query: function (_a) {
                    var id = _a.id;
                    return ({
                        method: 'PATCH',
                        url: "/chats/deleteOneChat/".concat(id),
                    });
                },
                invalidatesTags: ['Chats'],
            }),
            getExternalChatsByRestId: builder.query({
                query: function (_a) {
                    var restaurantId = _a.restaurantId;
                    return ({
                        url: "/external-chat/admin/restaurants/".concat(restaurantId, "/chats"),
                        method: 'GET',
                    });
                },
                providesTags: ['Chats'],
            }),
            getExternalChatsByTogetherActivityId: builder.query({
                query: function (_a) {
                    var activityId = _a.activityId;
                    return ({
                        url: "/external-chat/admin/together-activities/".concat(activityId, "/chats"),
                        method: 'GET',
                    });
                },
                providesTags: ['Chats'],
            }),
            getExternalChatById: builder.query({
                query: function (chatId) {
                    return ({
                        url: "/external-chat/admin/chats/".concat(chatId),
                        method: 'GET',
                    });
                },
                providesTags: ['Chats'],
            }),
            updateExternalChatIsPaid: builder.mutation({
                query: function (_a) {
                    var chatId = _a.chatId, isPaid = _a.isPaid;
                    return ({
                        url: "/external-chat/".concat(chatId, "/isPaid"),
                        method: 'PUT',
                        body: { isPaid: isPaid },
                    });
                },
                invalidatesTags: ['Chats'],
            }),
            deleteExternalChat: builder.mutation({
                query: function (chatId) {
                    return ({
                        url: "/external-chat/chats/".concat(chatId),
                        method: 'DELETE',
                    });
                },
                invalidatesTags: ['Chats'],
            }),
        });
    },
});
export var useGetUserChatsSummaryQuery = chatsApi.useGetUserChatsSummaryQuery, useGetAllMessagesWithSearchQuery = chatsApi.useGetAllMessagesWithSearchQuery, useGetChatsByRestIdQuery = chatsApi.useGetChatsByRestIdQuery, useGetAllMessagesQuery = chatsApi.useGetAllMessagesQuery, useGetChatByIdQuery = chatsApi.useGetChatByIdQuery, useGetChatsByRestIdWithPaginationQuery = chatsApi.useGetChatsByRestIdWithPaginationQuery, useDeleteChatMutation = chatsApi.useDeleteChatMutation, useUpdateIsPaidStatusMutation = chatsApi.useUpdateIsPaidStatusMutation;
export var useGetExternalChatsByRestIdQuery = chatsApi.useGetExternalChatsByRestIdQuery;
export var useGetExternalChatByIdQuery = chatsApi.useGetExternalChatByIdQuery;
export var useUpdateExternalChatIsPaidMutation = chatsApi.useUpdateExternalChatIsPaidMutation;
export var useDeleteExternalChatMutation = chatsApi.useDeleteExternalChatMutation;
export var useGetExternalChatsByTogetherActivityIdQuery = chatsApi.useGetExternalChatsByTogetherActivityIdQuery;
